import React from 'react';
import { fireEvent, render, screen } from '@testing-library/react';
import { MemoryRouter } from 'react-router-dom';
import ContractStaffPage from './index';
import axios from '../../api/httpClient';
import useCurrentEmployee from '../../hooks/useCurrentEmployee';

jest.mock('../../api/httpClient');
jest.mock('../../hooks/useCurrentEmployee');

const employee = {
  roleName: 'Head of Department',
  modulePermissions: [],
};

beforeEach(() => {
  useCurrentEmployee.mockReturnValue({ companyAccount: false, currentEmployee: employee, loading: false });
  axios.get.mockImplementation((url) => url.endsWith('/options')
    ? Promise.resolve({ data: { departments: [], projects: [], modules: [] } })
    : Promise.resolve({ data: { contractors: [] } }));
});

afterEach(() => jest.clearAllMocks());

test('shows the contract staff page and supports adding a contractor from the main action', async () => {
  render(
    <MemoryRouter>
      <ContractStaffPage />
    </MemoryRouter>,
  );

  expect(await screen.findByRole('heading', { name: 'Contract staff' })).toBeInTheDocument();
  fireEvent.click(screen.getByRole('button', { name: 'Add contract staff' }));

  expect(axios.get).toHaveBeenCalled();
  expect(screen.getByRole('button', { name: 'Add contract staff' })).toBeInTheDocument();
});